import cubejs, { Query, ResultSet } from '@cubejs-client/core';
import { useConfigStore } from 'Hooks/zustand/useConfigStore';
import { RULESET_ID_SESSION_KEY } from 'Utils';
import { useEffect, useState, useMemo } from 'react';
import { useAccessTokenStore } from 'Hooks/zustand/useAccessTokenStore';
import { useAuthenticationStore } from 'Hooks/zustand/useAuthenticationStore';

const useCubeReportQuery = (
    formValues: NewMerchantReportFormValues | undefined,
    countQuery: Query
): CubeReportQueryResponse => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<string>();
    const { appConfig } = useConfigStore.getState();
    const { accessToken } = useAccessTokenStore();
    const { authService } = useAuthenticationStore.getState();
    const [resultSet, setResultSet] = useState<ResultSet<unknown> | null>(null);
    const cubejsApi = useMemo(
        () =>
            cubejs(appConfig.cubeJsToken, {
                apiUrl: appConfig.cubeBaseURL,
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    ruleSetId: sessionStorage.getItem(RULESET_ID_SESSION_KEY) ?? ''
                }
            }),
        [appConfig.cubeBaseURL, appConfig.cubeJsToken, accessToken]
    );

    useEffect(() => {
        const makeQuery = async () => {
            try {
                setIsLoading(true);
                const response = await cubejsApi.load(countQuery);
                setResultSet(response);
            } catch (e) {
                setError('Error getting data from cubejs');
            } finally {
                setIsLoading(false);
            }
        };
        if (countQuery && Object.keys(countQuery).length && Boolean(formValues)) {
            makeQuery();
        }
    }, [authService, countQuery, formValues, cubejsApi]);

    return { resultSet, isLoading, error };
};
export default useCubeReportQuery;
